import React, { useEffect, useState } from "react";
import { userService } from "@/services";
import { GeneratorQRCode } from "@/components";
import "./ShareModal.css";

interface ShareModalProps {
  isOpen: boolean;
  onClose: () => void;
  uid: string;
  usernameSlug: string;
}

const ShareModal: React.FC<ShareModalProps> = ({
  isOpen,
  onClose,
  uid,
  usernameSlug,
}) => {
  const [referralData, setReferralData] = useState<string>("");
  const [copied, setCopied] = useState(false);

  const shareMessage = {
    title: `💘 Oii, pensei em você…`,
    text: `Te mandei esse acesso no Mimo Cupido 👀 👉`,
    body: `Depois me fala o que achou 😏`,
  };

  const profileUrl = `${window.location.origin}/cadastro?user=${usernameSlug || ""}&ref=${referralData || ""}`;

  // Gera o link da imagem do QR Code apontando para a URL de cadastro
  const qrCodeUrl = `https://chart.googleapis.com/chart?chs=180x180&cht=qr&chl=${encodeURIComponent(
    profileUrl,
  )}&choe=UTF-8`;

  const handleCopyLink = async () => {
    const params = `${shareMessage.title}\n${shareMessage.text}\n\n ${profileUrl} \n\n${shareMessage.body}`;

    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(params);

        setCopied(true);
        setTimeout(() => setCopied(false), 2000);

        return;
      } catch (err) {
        console.error("Erro na Clipboard API, tentando fallback...", err);
      }
    }

    // 2. Fallback para iPhone/Browsers Antigos
    const textArea = document.createElement("textarea");
    textArea.value = params;

    // Impede o scroll e esconde o elemento
    textArea.style.position = "fixed";
    textArea.style.left = "-9999px";
    textArea.style.top = "0";
    document.body.appendChild(textArea);

    textArea.focus();
    textArea.select();

    try {
      document.execCommand("copy");
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Falha total ao copiar", err);
    }

    document.body.removeChild(textArea);
  };

  const handleNativeShare = async () => {
    if (navigator.share) {
      const params = `${shareMessage.title}\n${shareMessage.text}\n\n ${profileUrl} \n\n${shareMessage.body}`;

      try {
        await navigator.share({ text: params });
      } catch (err) {
        console.log("Compartilhamento cancelado ou falhou", err);
      }
    } else {
      handleCopyLink();
    }
  };

  const getReferralData = async () => {
    try {
      const res = await userService.getOrCreateReferralCode(uid, usernameSlug);

      setReferralData(res.referralCode);
    } catch (err) {
      console.error("Erro ao carregar dados de indicação", err);
    }
  };

  useEffect(() => {
    if (isOpen) {
      getReferralData().then();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="share-modal-overlay" onClick={onClose}>
      <div
        className="share-modal-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="share-modal-header">
          <h3>Compartilhar perfil</h3>
          <button className="modal-close" onClick={onClose}>
            &times;
          </button>
        </div>

        <div className="share-modal-content">
          <div className="share-profile-preview">
            <p className="qr-instructions">
              Mostre o código abaixo para alguém se cadastrar pelo seu link
            </p>

            <div className="share-qr-wrapper">
              {referralData ? (
                <GeneratorQRCode code={profileUrl} />
              ) : (
                <div
                  className="qr-placeholder"
                  style={{ padding: "40px 0", color: "#aaa" }}
                >
                  Gerando código...
                </div>
              )}
            </div>
          </div>

          <div className="share-actions-grid">
            <button className="share-action-item" onClick={handleNativeShare}>
              <div className="icon-circle">
                <i className="share-icon">↗</i>
              </div>
              <span>Compartilhar</span>
            </button>

            <button className="share-action-item" onClick={handleCopyLink}>
              <div className="icon-circle">
                <i className="link-icon">🔗</i>
              </div>
              <span>{copied ? "Copiado!" : "Copiar link"}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareModal;
